import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Costs -> averageNetPrices
  '0-30': {
    id: 'avg.net.prices.0-30',
    defaultMessage: '$0 - $30,000',
  },
  '30-48': {
    id: 'avg.net.prices.30-48',
    defaultMessage: '$30,001 - $48,000',
  },
  '48-75': {
    id: 'avg.net.prices.48-75',
    defaultMessage: '$48,001 - $75,000',
  },
  '75-110': {
    id: 'avg.net.prices.75-110',
    defaultMessage: '$75,001 - $110,000',
  },
  '110+': {
    id: 'avg.net.prices.110-plus',
    defaultMessage: '$110,001+',
  },

  // Costs -> receivingAid
  'grant': {
    id: 'percentage.receiving.aid.grant',
    defaultMessage: 'Grant',
  },
  'pellGrant': {
    id: 'percentage.receiving.aid.pellGrant',
    defaultMessage: 'Pell Grant',
  },
  'studentLoan': {
    id: 'percentage.receiving.aid.loan',
    defaultMessage: 'Federal Student Loan',
  },

  // new
  'field_he_meets_full_fin_needs': {
    id: 'meets.full.financial.needs',
    defaultMessage: 'Meets Full Financial Needs',
  },
});

export default messages;
